import { Icon } from '@iconify/react';
import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';
import PhonelinkLockIcon from '@mui/icons-material/PhonelinkLock';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import InventoryIcon from '@mui/icons-material/Inventory';
import DataThresholdingIcon from '@mui/icons-material/DataThresholding';
import PrintIcon from '@mui/icons-material/Print';
import { PATH_DASHBOARD } from '../../../routes/paths';

const navConfig = [
  {
    items: [
      { title: 'Dashboard', path: '/dashboard/home', icon: <Icon icon="ri:dashboard-line" /> },
      {
        title: 'Attributes',
        icon: <SettingsSuggestIcon />,
        children: [
          { title: 'Brand', path: PATH_DASHBOARD.attributes.brand },
          { title: 'Series', path: PATH_DASHBOARD.attributes.series },
          { title: 'Model', path: PATH_DASHBOARD.attributes.model },
          { title: 'Color', path: PATH_DASHBOARD.attributes.color },
          { title: 'Storage', path: PATH_DASHBOARD.attributes.storage },
          { title: 'Network', path: PATH_DASHBOARD.attributes.network },
          { title: 'Category', path: PATH_DASHBOARD.attributes.category },
        ],
      },
      { title: 'Manage Web Products', path: PATH_DASHBOARD.eCommerce.list, icon: <SettingsSuggestIcon /> },
      { title: 'Add Variants', path: PATH_DASHBOARD.eCommerce.variantManagment, icon: <InventoryIcon /> },
      { title: 'Manage Stock', path: PATH_DASHBOARD.stock.inventoryStock, icon: <InventoryIcon /> },
      { title: 'Print IMEI', path: PATH_DASHBOARD.printIMEI.print, icon: <PrintIcon /> },
      { title: 'Unlock Codes', path: PATH_DASHBOARD.unlockcode.unlockcode, icon: <PhonelinkLockIcon /> },
      { title: 'Inventory', path: PATH_DASHBOARD.dorm.inventory, icon: <Icon icon="ic:sharp-inventory" /> },
      {
        title: 'Order Puller',
        path: PATH_DASHBOARD.element.orders,
        icon: <Icon icon="streamline:briefcase-dollar-solid" />,
      },
      { title: 'Dispatch Shipments', path: PATH_DASHBOARD.dispatcher.dispatch, icon: <LocalShippingIcon /> },
      { title: 'Tester Shipments', path: PATH_DASHBOARD.tester.testManagement, icon: <LocalShippingIcon /> },
      { title: 'Shipped Items', path: PATH_DASHBOARD.shipped.allshippeditems, icon: <DataThresholdingIcon /> },
      { title: 'Return Items', path: PATH_DASHBOARD.return.allreturnitems, icon: <DataThresholdingIcon /> },
    ],
  },
  {
    items: [
      { title: 'Dashboard', path: '/dashboard/home', icon: <Icon icon="ri:dashboard-line" /> },
      {
        title: 'Order Puller',
        path: PATH_DASHBOARD.element.orders,
        icon: <Icon icon="streamline:briefcase-dollar-solid" />,
      },
    ],
  },
  {
    items: [
      { title: 'Dashboard', path: '/dashboard/home', icon: <Icon icon="ri:dashboard-line" /> },
      { title: 'Inventory', path: PATH_DASHBOARD.dorm.inventory, icon: <Icon icon="ic:sharp-inventory" /> },
    ],
  },
  {
    items: [
      { title: 'Dashboard', path: '/dashboard/home', icon: <Icon icon="ri:dashboard-line" /> },
      { title: 'Dispatch Shipments', path: PATH_DASHBOARD.dispatcher.dispatch, icon: <LocalShippingIcon /> },
      { title: 'Dispatch Returns All Shipped Items', path: PATH_DASHBOARD.shipped.allshippeditems, icon: <DataThresholdingIcon /> },
      { title: 'Return Items', path: PATH_DASHBOARD.return.allreturnitems, icon: <DataThresholdingIcon /> },
    ],
  },
  {
    items: [
      { title: 'Dashboard', path: '/dashboard/home', icon: <Icon icon="ri:dashboard-line" /> },
      { title: 'Manage Stock', path: PATH_DASHBOARD.stock.inventoryStock, icon: <InventoryIcon /> },
    ],
  },
  {
    items: [
      { title: 'Dashboard', path: '/dashboard/home', icon: <Icon icon="ri:dashboard-line" /> },
      { title: 'Unlock Codes', path: PATH_DASHBOARD.unlockcode.unlockcode, icon: <PhonelinkLockIcon /> },
      { title: 'Tester Shipments', path: PATH_DASHBOARD.tester.testManagement, icon: <LocalShippingIcon /> },
    ],
  },
];

export default navConfig;
